import { render } from "./userCard.vue?vue&type=template&id=dd8b85c4&scoped=true"
import script from "./userCard.vue?vue&type=script&lang=js"
export * from "./userCard.vue?vue&type=script&lang=js"

import "./userCard.vue?vue&type=style&index=0&id=dd8b85c4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-dd8b85c4"

export default script